// import React from "react";
// import { useLanguage } from "../../contexts/LanguageContext";
// import { translations } from "../../i18n";
// import importImage from "../../utils/images/importImage";
// import { Award, Lightbulb } from 'lucide-react'; // Importing icons for creativity

// const AboutUs = () => {
//   // Use the dynamically fetched image and data
//   const secImage1 = importImage("section-image1.jpg");
//   const { language } = useLanguage();
//   const aboutUsData = translations[language]?.about;

//   if (!aboutUsData) {
//     return <p>Loading...</p>;
//   }

//   // Fallback data structure for the dynamic content
//   const dynamicAboutUsData = {
//     heading: aboutUsData.heading || "Empowering Your Digital Journey",
//     description: aboutUsData.description || "Welcome to Toko Yarn...",
//     ourStory: aboutUsData.ourStory || {
//       title: "Our Core Values",
//       content: "At Toko Yarn, integrity, transparency, and reliability form the core of everything we do..."
//     },
//     ourApproach: aboutUsData.ourApproach || {
//       title: "Weaving Success",
//       content: "Let us help you weave the threads of success. Contact us today to learn more..."
//     },
//     image: secImage1
//   };

//   return (
//     // Add Bootstrap CDN link to your HTML file to make this work
//     // <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css" rel="stylesheet">
//     <section id="about-us-1" className="py-5 py-sm-5 py-md-5 py-lg-5 font-sans">
//       <div className="container">
//         <div className="row g-5 align-items-center">
          
//           {/* Left Side: Text Content */}
//           <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
//             <h2 className="display-4 fw-bold mb-4 text-dark">{dynamicAboutUsData.heading}</h2>
//             <p className="text-secondary mb-4">{dynamicAboutUsData.description}</p>
            
//             {/* Our Story section with creative icons */}
//             <div className="d-flex mb-4 align-items-center">
//               <div className="d-flex p-3 bg-primary bg-opacity-10 text-white rounded-3 me-3 fs-3 flex-shrink-0">
//                 <Award className="h-6 w-6" />
//               </div>
//               <div>
//                 <h5 className="h5 fw-bold mb-2 text-dark">{dynamicAboutUsData.ourStory.title}</h5>
//                 <p className="text-secondary mb-0">{dynamicAboutUsData.ourStory.content}</p>
//               </div>
//             </div>
            
//             {/* Our Approach section with creative icons */}
//             <div className="d-flex align-items-center">
//               <div className="d-flex p-3 bg-primary bg-opacity-10 text-white rounded-3 me-3 fs-3 flex-shrink-0">
//                 <Lightbulb className="h-6 w-6" />
//               </div>
//               <div>
//                 <h5 className="h5 fw-bold mb-2 text-dark">{dynamicAboutUsData.ourApproach.title}</h5>
//                 <p className="text-secondary mb-0">{dynamicAboutUsData.ourApproach.content}</p>
//               </div>
//             </div>

//             {/* Call-to-action button */}
//             {/*<button className="btn btn-lg btn-primary mt-4">
//               Get in Touch
//             </button>*/}
//           </div>

//           {/* Right Side: Image */}
//           <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3s">
//             <div className="position-relative overflow-hidden rounded-4 shadow-lg h-100">
//               <img
//                 src={dynamicAboutUsData.image}
//                 className="img-fluid w-100 h-100"
//                 alt="Our Story"
//                 style={{ objectFit: "cover" }}
//                 onError={(e) => {
//                   e.target.onerror = null;
//                   e.target.src = 'https://placehold.co/600x400/0d6efd/ffffff?text=About+Us';
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default AboutUs;



import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { translations } from "../../i18n";
import importImage from "../../utils/images/importImage";


import {
  Shield,
  Lightbulb,
  Target,
  Eye,
  CheckCircle,
  Layers,
  BadgeCheck,
  DollarSign,
  Cpu,
  HeadphonesIcon,
  Tag,
  Truck,
  Lock,
  TrendingUp,
  Headphones,
} from "lucide-react";

const bgImg = importImage("contact-bg.jpg");

/* ─────────────────────────────────────────────
   Inline styles / design tokens
───────────────────────────────────────────── */
const NAVY = "#1a2356";
const ORANGE = "#f7941d";
const LIGHT_BG = "#f8f9fb";

const styles = {
  /* ── Hero banner ── */
  heroBanner: {
    position: "relative",
    minHeight: 220,
    background: `linear-gradient(rgba(26,35,86,0.72), rgba(26,35,86,0.72))`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    color: "#fff",
    fontSize: "2.4rem",
    fontWeight: 700,
    letterSpacing: 1,
    margin: 0,
  },

  /* ── Section wrappers ── */
  section: { padding: "72px 0" },
  sectionLight: { padding: "72px 0", background: LIGHT_BG },
  sectionNavy: { padding: "72px 0", background: NAVY },

  /* ── Typography ── */
  sectionLabel: {
    color: ORANGE,
    fontWeight: 700,
    fontSize: "1rem",
    textTransform: "uppercase",
    letterSpacing: 2,
    marginBottom: 6,
  },
  sectionTitle: {
    color: NAVY,
    fontWeight: 800,
    fontSize: "2rem",
    lineHeight: 1.25,
    marginBottom: 16,
  },
  sectionTitleWhite: {
    color: "#fff",
    fontWeight: 800,
    fontSize: "2rem",
    lineHeight: 1.25,
    marginBottom: 16,
  },
  bodyText: { color: "#555", lineHeight: 1.75, marginBottom: 0 },

  /* ── Orange accent underline ── */
  orangeUnderline: {
    display: "inline-block",
    borderBottom: `3px solid ${ORANGE}`,
    paddingBottom: 2,
    color: ORANGE,
  },

  /* ── Icon circle ── */
  iconCircle: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: NAVY,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginRight: 14,
  },
  iconCircleOrange: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: ORANGE,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    marginRight: 14,
  },

  /* ── Cards ── */
  purposeCard: {
    background: "#fff",
    borderRadius: 12,
    padding: "32px 28px",
    height: "100%",
    boxShadow: "0 2px 16px rgba(26,35,86,0.07)",
  },
  cardTitle: { color: NAVY, fontWeight: 700, fontSize: "1.15rem", marginBottom: 10 },
  cardBody: { color: "#666", lineHeight: 1.7, margin: 0 },

  /* ── Mission checklist item ── */
  missionItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "14px 20px",
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 1px 8px rgba(26,35,86,0.06)",
    marginBottom: 14,
  },

  /* ── Differentiator row ── */
  diffRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 14,
    marginBottom: 22,
  },
  diffIconWrap: {
    width: 42,
    height: 42,
    borderRadius: 8,
    background: NAVY,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  diffTitle: { color: NAVY, fontWeight: 700, fontSize: "0.95rem", marginBottom: 2 },
  diffBody: { color: "#666", fontSize: "0.88rem", margin: 0, lineHeight: 1.55 },

  /* ── Feature box ── */
  featureBox: {
    display: "flex",
    alignItems: "center",
    gap: 14,
    background: "#fff",
    border: `1.5px solid #e8eaf0`,
    borderRadius: 10,
    padding: "18px 20px",
    marginBottom: 16,
  },
  featureIconWrap: {
    width: 48,
    height: 48,
    borderRadius: 8,
    background: NAVY,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  featureLabel: { color: NAVY, fontWeight: 700, fontSize: "0.95rem", margin: 0 },

  /* ── CTA banner ── */
  ctaBanner: {
    background: NAVY,
    padding: "60px 0",
    textAlign: "center",
  },
  ctaTitle: { color: "#fff", fontWeight: 800, fontSize: "2.2rem", marginBottom: 10 },
  ctaSubtitle: { color: "#c7cde8", marginBottom: 28 },
  ctaBtn: {
    background: ORANGE,
    color: "#fff",
    border: "none",
    borderRadius: 6,
    padding: "12px 36px",
    fontWeight: 700,
    fontSize: "1rem",
    cursor: "pointer",
    textTransform: "uppercase",
    letterSpacing: 1,
  },

  /* ── Orange ring image collage ── */
  collageWrap: {
    position: "relative",
    width: "100%",
    maxWidth: 440,
    margin: "0 auto",
  },
  ringDecor: {
    position: "absolute",
    width: 220,
    height: 220,
    borderRadius: "50%",
    border: `14px solid ${ORANGE}`,
    zIndex: 0,
  },
  sectionWithBg: {
    padding: "80px 0",
    backgroundImage: `url(${bgImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  combinedBg: {
    backgroundImage: `url(${bgImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

/* ─────────────────────────────────────────────
   Sub-components
───────────────────────────────────────────── */

/** Two stacked images with orange ring decoration (left layout) */
const ImageCollageLeft = ({ img1, img2 }) => (
  <div style={{ position: "relative", width: "100%", maxWidth: 420, margin: "0 auto" }}>
    {/* Orange ring top-left */}
    <div
      style={{
        ...styles.ringDecor,
        top: -24,
        left: -24,
        width: 200,
        height: 200,
      }}
    />
    <img
      src={img1}
      alt="About 1"
      style={{
        width: "65%",
        borderRadius: 12,
        position: "relative",
        zIndex: 1,
        objectFit: "cover",
        aspectRatio: "4/3",
        boxShadow: "0 4px 20px rgba(0,0,0,0.13)",
      }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = "https://placehold.co/320x240/1a2356/ffffff?text=Toko+Yarn";
      }}
    />
    <img
      src={img2}
      alt="About 2"
      style={{
        width: "60%",
        borderRadius: 12,
        position: "absolute",
        right: 0,
        bottom: -36,
        zIndex: 2,
        objectFit: "cover",
        aspectRatio: "4/3",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = "https://placehold.co/260x200/f7941d/ffffff?text=Team";
      }}
    />
  </div>
);

/** Two stacked images with orange ring decoration (right layout) */
const ImageCollageRight = ({ img1, img2 }) => (
  <div style={{ position: "relative", width: "100%", maxWidth: 440, margin: "0 auto", minHeight: 340 }}>
    {/* Orange ring bottom-right */}
    <div
      style={{
        ...styles.ringDecor,
        bottom: -20,
        right: -20,
        width: 210,
        height: 210,
      }}
    />
    <img
      src={img1}
      alt="Digital 1"
      style={{
        width: "62%",
        borderRadius: 12,
        position: "absolute",
        top: 0,
        right: 0,
        zIndex: 1,
        objectFit: "cover",
        aspectRatio: "4/3",
        boxShadow: "0 4px 20px rgba(0,0,0,0.13)",
      }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = "https://placehold.co/280x210/1a2356/ffffff?text=Digital";
      }}
    />
    <img
      src={img2}
      alt="Digital 2"
      style={{
        width: "55%",
        borderRadius: 12,
        position: "absolute",
        bottom: 0,
        left: 0,
        zIndex: 2,
        objectFit: "cover",
        aspectRatio: "1/1",
        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
      }}
      onError={(e) => {
        e.target.onerror = null;
        e.target.src = "https://placehold.co/240x240/f7941d/ffffff?text=Yarn";
      }}
    />
  </div>
);

/* ─────────────────────────────────────────────
   Main component
───────────────────────────────────────────── */
const AboutUs = () => {
  const { language } = useLanguage();
  const aboutUsData = translations[language]?.aboutData;

  const splitHeading = (text, highlightCount = 2) => {
    if (!text) return { normal: "", highlight: "" };

    const words = text.split(" ");

    return {
      normal: words.slice(0, -highlightCount).join(" "),
      highlight: words.slice(-highlightCount).join(" "),
    };
  };

  const about2Heading = splitHeading(
    aboutUsData.about2?.heading || "Taking you on a digital journey"
  );

  const heroHeading = splitHeading(
    aboutUsData?.about?.heading || "Empowering Your Digital Journey"
  );

  // Images
  const secImage1 = importImage("section-image1.jpg");
  const secImage2 = importImage("section-image2.jpg");
  const secImage3 = importImage("section-image3.jpg");
  const secImage4 = importImage("section-image4.jpg");

  if (!aboutUsData) return <p>Loading...</p>;

  // ── Mission points ──
  const missionPoints = aboutUsData?.mission?.content || [
    "To provide a trusted, transparent, and efficient platform for yarn buyers and sellers.",
    "To support businesses with smart logistics, secure payments, and financial solutions.",
    "To drive innovation in the textile supply chain through technology.",
    "To foster long-term relationships built on reliability and shared success.",
  ];

  // ── Differentiators ──
  // const differentiators = aboutUsData.differentiators || [
  //   {
  //     icon: <Layers size={20} color="#fff" />,
  //     title: "End-to-End Supply Chain Support",
  //     body: "From sourcing to delivery, we manage the entire process to ensure timely and quality fulfillment.",
  //   },
  //   {
  //     icon: <BadgeCheck size={20} color="#fff" />,
  //     title: "Verified Supplier Network",
  //     body: "Every seller is vetted for authenticity, quality standards, and delivery performance.",
  //   },
  //   {
  //     icon: <DollarSign size={20} color="#fff" />,
  //     title: "Competitive Pricing & Real-Time Offers",
  //     body: "Access the best prices through direct sourcing and live deals from top manufacturers.",
  //   },
  //   {
  //     icon: <Cpu size={20} color="#fff" />,
  //     title: "Tech-Driven Platform",
  //     body: "Our smart tools make it easy to search, compare, order, and track.",
  //   },
  //   {
  //     icon: <HeadphonesIcon size={20} color="#fff" />,
  //     title: "Human-Centric Support",
  //     body: "Our team is always ready to assist with personalized solutions, whether you're a first-time buyer or a seasoned trader.",
  //   },
  // ];

  // // ── Features ──
  // const features = aboutUsData.features || [
  //   { icon: <Tag size={22} color="#fff" />, label: "Best Price Guarantee" },
  //   { icon: <Truck size={22} color="#fff" />, label: "Door-to-Door Logistics" },
  //   { icon: <Shield size={22} color="#fff" />, label: "Merchant Protection" },
  //   { icon: <Lock size={22} color="#fff" />, label: "Secure Payments" },
  //   { icon: <TrendingUp size={22} color="#fff" />, label: "Trade Finance" },
  //   { icon: <Headphones size={22} color="#fff" />, label: "Customer Support" },
  // ];

  const rawDifferentiators = aboutUsData?.differentiators?.items;

const differentiators = rawDifferentiators?.length
  ? rawDifferentiators.map((text, i) => {
      const icons = [Layers, BadgeCheck, DollarSign, Cpu, HeadphonesIcon];
      const Icon = icons[i] || Layers;

      const [title, body] = text.split(":");

      return {
        icon: <Icon size={20} color="#fff" />,
        title: title?.trim(),
        body: body?.trim(),
      };
    })
  : [
      {
        icon: <Layers size={20} color="#fff" />,
        title: "End-to-End Supply Chain Support",
        body: "From sourcing to delivery...",
      },
      {
        icon: <BadgeCheck size={20} color="#fff" />,
        title: "Verified Supplier Network",
        body: "Every seller is vetted...",
      },
      {
        icon: <DollarSign size={20} color="#fff" />,
        title: "Competitive Pricing & Real-Time Offers",
        body: "Access the best prices...",
      },
      {
        icon: <Cpu size={20} color="#fff" />,
        title: "Tech-Driven Platform",
        body: "Our smart tools...",
      },
      {
        icon: <HeadphonesIcon size={20} color="#fff" />,
        title: "Human-Centric Support",
        body: "Our team is always ready...",
      },
    ];

  // ── Features ──
  const rawFeatures = aboutUsData?.features;

  const features = rawFeatures?.length
    ? rawFeatures.map((item, i) => {
        const iconMap = {
          "bi-cash-coin": Tag,
          "bi-truck": Truck,
          "bi-shield-check": Shield,
          "bi-credit-card-2-front": Lock,
          "bi-graph-up-arrow": TrendingUp,
          "bi-headphones": Headphones,
        };

        const Icon = iconMap[item.icon] || Tag;

        return {
          icon: <Icon size={22} color="#fff" />,
          label: item.title,
        };
      })
    : [
        { icon: <Tag size={22} color="#fff" />, label: "Best Price Guarantee" },
        { icon: <Truck size={22} color="#fff" />, label: "Door-to-Door Logistics" },
        { icon: <Shield size={22} color="#fff" />, label: "Merchant Protection" },
        { icon: <Lock size={22} color="#fff" />, label: "Secure Payments" },
        { icon: <TrendingUp size={22} color="#fff" />, label: "Trade Finance" },
        { icon: <Headphones size={22} color="#fff" />, label: "Customer Support" },
      ];

  return (
    <div style={{ color: "#333" }}>

      {/* ── HERO BANNER ── */}
      {/* <div
        style={{
          ...styles.heroBanner,
          backgroundImage: `linear-gradient(rgba(26,35,86,0.72), rgba(26,35,86,0.72)), url(${secImage1})`,
        }}
      >
        <h1 style={styles.heroTitle}>About Us</h1>
      </div> */}

      {/* ══════════════════════════════════════
          SECTION 1 — Empowering Your Digital Journey
      ══════════════════════════════════════ */}
      <section style={styles.section}>
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left: collage */}
            <div className="col-lg-5 d-flex justify-content-center" style={{ paddingBottom: 36 }}>
              <ImageCollageLeft img1={secImage1} img2={secImage2} />
            </div>

            {/* Right: text */}
            <div className="col-lg-7">
              <h2 style={styles.sectionTitle}>
                {heroHeading.normal}{" "}
                <span style={styles.orangeUnderline}>
                  {heroHeading.highlight}
                </span>
              </h2>
              <p style={styles.bodyText}>
                {aboutUsData?.about?.description ||
                  "Welcome to Toko Yarn, your trusted partner in connecting yarn manufacturers, suppliers, and buyers across the textile industry. With a deep understanding of the global yarn market and a passion for quality craftsmanship, we specialize in bridging the gap between supply and demand, ensuring seamless transactions and mutually beneficial partnerships."}
              </p>

              {/* Core Values row */}
              <div style={{ display: "flex", alignItems: "flex-start", marginTop: 28, marginBottom: 18 }}>
                <div style={styles.iconCircle}>
                  <Shield size={20} color="#fff" />
                </div>
                <div>
                  <h5 style={{ color: NAVY, fontWeight: 700, marginBottom: 4, fontSize: "1rem" }}>
                    {aboutUsData.about.ourStory?.title || "Our Core Values"}
                  </h5>
                  <p style={styles.bodyText}>
                    {aboutUsData?.about?.ourStory?.content ||
                      "At Toko Yarn, integrity, transparency, and reliability form the core of everything we do. From negotiating the best terms to ensuring timely delivery, we are here to make your yarn sourcing experience efficient and hassle-free."}
                  </p>
                </div>
              </div>

              {/* Weaving Success row */}
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <div style={styles.iconCircle}>
                  <Lightbulb size={20} color="#fff" />
                </div>
                <div>
                  <h5 style={{ color: NAVY, fontWeight: 700, marginBottom: 4, fontSize: "1rem" }}>
                    {aboutUsData.about.ourApproach?.title || "Weaving Success"}
                  </h5>
                  <p style={styles.bodyText}>
                    {aboutUsData?.about2?.ourApproach?.content ||
                      "Let us help you weave the threads of success. Contact us today to learn more about how we can add value to your business."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 2 — Taking you on a digital journey
      ══════════════════════════════════════ */}
      <div style={styles.combinedBg}>

      <section style={ styles.section }>
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left: text */}
            <div className="col-lg-7">
              <h2 style={styles.sectionTitle}>
                {about2Heading.normal}{" "}
                <span style={styles.orangeUnderline}>
                  {about2Heading.highlight}
                </span>
              </h2>
              <p style={styles.bodyText}>
                {aboutUsData.about2?.description ||
                  "Toko Yarn allows your business to achieve new heights with digital presence. With digital presence you come to know about the prices, trends and information in real time. Which enables Sellers to increase their reach and sales and allows buyers to find raw materials faster at lower costs."}
              </p>

              <div style={{ display: "flex", alignItems: "flex-start", marginTop: 24 }}>
                <div style={styles.iconCircle}>
                  <Target size={20} color="#fff" />
                </div>
                <p style={{ ...styles.bodyText, marginTop: 4 }}>
                  {aboutUsData?.about2?.ourApproach?.content ||
                    "So join us at Toko Yarn and let us help your business achieve new heights with digital presence."}
                </p>
              </div>
            </div>

            {/* Right: collage */}
            <div className="col-lg-5 d-flex justify-content-center" style={{ paddingBottom: 36 }}>
              <ImageCollageRight img1={secImage3} img2={secImage4} />
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 3 — Purpose / Vision cards
      ══════════════════════════════════════ */}
      <section style={styles.section}>
        <div className="container">
          <div className="row g-4">
            {/* Our Purpose */}
            <div className="col-md-6">
              <div style={styles.purposeCard}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
                  <div style={{ ...styles.iconCircle, marginRight: 12 }}>
                    <Target size={20} color="#fff" />
                  </div>
                  <h3 style={{ ...styles.cardTitle, marginBottom: 0 }}>
                    {aboutUsData.purpose?.title || "Our Purpose"}
                  </h3>
                </div>
                <p style={styles.cardBody}>
                  {aboutUsData.purpose?.content ||
                    "To make an impact on the industry by taking you on a digital journey. To connect the yarn industry through a unified digital platform that simplifies trade, promotes fair pricing, and supports sustainable growth for every stakeholder."}
                </p>
              </div>
            </div>

            {/* Our Vision */}
            <div className="col-md-6">
              <div style={styles.purposeCard}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
                  <div style={{ ...styles.iconCircle, marginRight: 12 }}>
                    <Eye size={20} color="#fff" />
                  </div>
                  <h3 style={{ ...styles.cardTitle, marginBottom: 0 }}>
                    {aboutUsData.vision?.title || "Our Vision"}
                  </h3>
                </div>
                <p style={styles.cardBody}>
                  {aboutUsData.vision?.content ||
                    "To make the textile industry organized on all levels. To become Asia's most trusted and efficient digital marketplace for yarn, enabling seamless trade and value creation for the global textile ecosystem."}
                </p>
              </div>
            </div>
          </div>

          {/* Our Mission */}
          <div style={{ marginTop: 48 }}>
            <h3 style={{ ...styles.sectionTitle, marginBottom: 28 }}>
              Our <span style={styles.orangeUnderline}>Mission</span>
            </h3>
            <div className="row g-3">
              {missionPoints.map((point, i) => (
                <div key={i} className="col-md-6">
                  <div style={styles.missionItem}>
                    <CheckCircle size={20} color={ORANGE} style={{ flexShrink: 0, marginTop: 2 }} />
                    <p style={{ margin: 0, color: "#555", lineHeight: 1.65, fontSize: "0.93rem" }}>
                      {point}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      </div>

      {/* ══════════════════════════════════════
          SECTION 4 — Differentiators
      ══════════════════════════════════════ */}
      <section style={styles.sectionLight}>
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Left: collage */}
            <div className="col-lg-5 d-flex justify-content-center" style={{ paddingBottom: 36 }}>
              <ImageCollageLeft img1={secImage1} img2={secImage3} />
            </div>

            {/* Right: list */}
            <div className="col-lg-7">
              <h2 style={styles.sectionTitle}>
                Our <span style={styles.orangeUnderline}>Differentiators</span>
              </h2>
              {differentiators.map((d, i) => (
                <div key={i} style={styles.diffRow}>
                  <div style={styles.diffIconWrap}>{d.icon}</div>
                  <div>
                    <p style={styles.diffTitle}>{d.title}</p>
                    <p style={styles.diffBody}>{d.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════
          SECTION 5 — Our Features
      ══════════════════════════════════════ */}
      <section style={styles.section}>
        <div className="container">
          <h2
            style={{
              ...styles.sectionTitle,
              textAlign: "center",
              marginBottom: 40,
            }}
          >
            Our <span style={styles.orangeUnderline}>Features</span>
          </h2>

          <div className="row g-3 justify-content-center">
            {features.map((f, i) => (
              <div key={i} className="col-md-4 col-sm-6">
                <div style={styles.featureBox}>
                  <div style={styles.featureIconWrap}>{f.icon}</div>
                  <p style={styles.featureLabel}>{f.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;